import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './Tooltip.module.scss';

const Tooltip = ({
  children,
  content,
  position = 'top',
  delay = 0,
  disabled = false,
  ...theRestOfTheProps
}) => {
  const [isVisible, setIsVisible] = useState(false);

  if (disabled || !content) {
    return children;
  }

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  const className = clsx(
    styles.Tooltip,
    styles[`Tooltip--${position}`]
  );

  return (
    <div
      className={styles.TooltipWrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...theRestOfTheProps}
    >
      {children}
      {isVisible && (
        <div className={className} role="tooltip">
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;